import { Link, useLocation } from "react-router-dom";
import { getUserToken } from "@/lib/api";

export const PublicHeader = ({ transparent = false }) => {
  const { pathname } = useLocation();
  const linkBase = `nav-link text-sm tracking-[0.18em] uppercase font-sans ${
    transparent ? "text-[#f9f8f6]/85 hover:text-[#f9f8f6]" : "text-[#1a1918] hover:text-[#1a1918]"
  }`;
  const isLoggedIn = !!getUserToken();

  return (
    <header
      data-testid="public-header"
      className={`absolute top-0 left-0 right-0 z-30 ${transparent ? "" : "relative bg-[#f9f8f6] border-b border-[#e5e1d8]"}`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-6 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-link"
          className={`font-serif tracking-[0.25em] text-base sm:text-lg ${transparent ? "text-[#f9f8f6]" : "text-[#1a1918]"}`}
        >
          ATTRAVERSANDO
        </Link>
        <nav className="flex items-center gap-4 sm:gap-8">
          <Link
            to="/"
            data-testid="nav-home"
            className={`${linkBase} ${pathname === "/" ? "active" : ""}`}
          >
            Diario
          </Link>
          <Link
            to="/archivio"
            data-testid="nav-archive"
            className={`${linkBase} ${pathname === "/archivio" ? "active" : ""}`}
          >
            Archivio
          </Link>
          <Link
            to={isLoggedIn ? "/riservati" : "/accedi"}
            data-testid="nav-reserved"
            className={`${linkBase} ${pathname.startsWith("/riservati") || pathname === "/accedi" ? "active" : ""}`}
          >
            Riservati
          </Link>
          <Link
            to="/admin/login"
            data-testid="nav-admin"
            className={`${linkBase} hidden sm:inline-block`}
          >
            Studio
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default PublicHeader;
